import { NewdanhmucphieuxuatService } from 'src/services/newdanhmucphieuxuat.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const NEWDANHMUCPHIEUXUAT_NEW_CARE_SUCCESS = 'NEWDANHMUCPHIEUXUAT:NEW_CARE_SUCCESS'
export const NEWDANHMUCPHIEUXUAT_LIST_SUCCESS = 'NEWDANHMUCPHIEUXUAT:FIND_ALL_SUCCESS'
export const NEWDANHMUCPHIEUXUAT_LIST_FAILD = 'NEWDANHMUCPHIEUXUAT:FIND_ALL_FAILD'
export const NEWDANHMUCPHIEUXUAT_COUNT_ASSIGN_SUCCESS = 'NEWDANHMUCPHIEUXUAT:COUNT_ASSIGN_SUCCESS'
export const NEWDANHMUCPHIEUXUAT_COUNT_ASSIGN_FAILD = 'NEWDANHMUCPHIEUXUAT:COUNT_ASSIGN_FAILD'

export const NEWDANHMUCPHIEUXUAT_CREATE_SUCCESS = 'NEWDANHMUCPHIEUXUAT:CREATE_SUCCESS'
export const NEWDANHMUCPHIEUXUAT_CREATE_FAILD = 'NEWDANHMUCPHIEUXUAT:CREATE_FAILD'

export const NEWDANHMUCPHIEUXUAT_IMPORT_SUCCESS = 'NEWDANHMUCPHIEUXUAT:IMPORT_SUCCESS'
export const NEWDANHMUCPHIEUXUAT_SAVE_SUCCESS = 'NEWDANHMUCPHIEUXUAT:SAVE_SUCCESS'
export const NEWDANHMUCPHIEUXUAT_SAVE_FAILD = 'NEWDANHMUCPHIEUXUAT:SAVE_SUCCESS'

export const NEWDANHMUCPHIEUXUAT_DEL_SUCCESS = 'NEWDANHMUCPHIEUXUAT:DEL_SUCCESS'
export const NEWDANHMUCPHIEUXUAT_DEL_FAILD = 'NEWDANHMUCPHIEUXUAT:DEL_FAILD'

export const NEWDANHMUCPHIEUXUAT_ONE_SUCCESS = 'NEWDANHMUCPHIEUXUAT:FIND_ONE_SUCCESS'
export const NEWDANHMUCPHIEUXUAT_ONE_FAILD = 'NEWDANHMUCPHIEUXUAT:FIND_ONE_FAILD'

export const NEWDANHMUCPHIEUXUAT_HISTORY_LIST_SUCCESS = 'NEWDANHMUCPHIEUXUAT:HISTORY_FIND_ALL_SUCCESS'
export const NEWDANHMUCPHIEUXUAT_HISTORY_LIST_FAILD = 'NEWDANHMUCPHIEUXUAT:HISTORY_FIND_ALL_FAILD'

export const NEWDANHMUCPHIEUXUAT_UPDATE_FILTER = 'NEWDANHMUCPHIEUXUAT:NEWDANHMUCPHIEUXUAT_UPDATE_FILTER'

export const NEWDANHMUCPHIEUXUAT_LIST_EXPORT_SUCCESS = 'NEWDANHMUCPHIEUXUAT:FIND_ALL_EXPORT_SUCCESS'
export const NEWDANHMUCPHIEUXUAT_LIST_EXPORT_FAILD = 'NEWDANHMUCPHIEUXUAT:FIND_ALL_EXPORT_FAILD'

export const NEWDANHMUCPHIEUXUAT_UPDATE_HOMEPAGE_FILTER = 'NEWDANHMUCPHIEUXUAT:NEWDANHMUCPHIEUXUAT_UPDATE_HOMEPAGE_FILTER'

export const NEWDANHMUCPHIEUXUAT_HOMEPAGE_LIST_SUCCESS = 'NEWDANHMUCPHIEUXUAT:FIND_HOMEPAGE_LIST_SUCCESS'
export const NEWDANHMUCPHIEUXUAT_HOMEPAGE_LIST_FAILD = 'NEWDANHMUCPHIEUXUAT:FIND_HOMEPAGE_LIST_FAILD'

export const NEWDANHMUCPHIEUXUAT_HOMEPAGE_ONE_SUCCESS = 'NEWDANHMUCPHIEUXUAT:FIND_HOMEPAGE_ONE_SUCCESS'
export const NEWDANHMUCPHIEUXUAT_HOMEPAGE_ONE_FAILD = 'NEWDANHMUCPHIEUXUAT:FIND_HOMEPAGE_ONE_FAILD'

export const NEWDANHMUCPHIEUXUAT_ORDER_SUCCESS = 'NEWDANHMUCPHIEUXUAT:ORDER_SUCCESS'
export const NEWDANHMUCPHIEUXUAT_ORDER_FAILD = 'NEWDANHMUCPHIEUXUAT:ORDER_FAILD'

export const NEWDANHMUCPHIEUXUAT_GET_SIM_ANALYSIS_SUCCESS = 'NEWDANHMUCPHIEUXUAT:GET_SIM_ANALYSIS_SUCCESS'
export const NEWDANHMUCPHIEUXUAT_GET_SIM_ANALYSIS_FAILD = 'NEWDANHMUCPHIEUXUAT:GET_SIM_ANALYSIS_FAILD'

export const NEWDANHMUCPHIEUXUAT_HANDLE_IMPORT_ERRORS = 'NEWDANHMUCPHIEUXUAT:NEWDANHMUCPHIEUXUAT_HANDLE_IMPORT_ERRORS'

export const NewdanhmucphieuxuatAction = {
    list,
    findAssign,
    create,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    findOne,
    updateFilter,
    saveDataUpload,
    findPackage,
    listExport,
    listNoLimit,
    homepageList,
    updateHomepageFilter,
    homepageFindOne,
    sendOrder,
    getSimAnalysis,
    checkSoKhungSoMay,
}

function checkSoKhungSoMay(payload) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            // dispatch(AppAction.appLoading(true));
            NewdanhmucphieuxuatService.checkSoKhungSoMay(payload).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            }).finally(() => {
                // dispatch(AppAction.appLoading(false));
            })
        })
    };
}

function getSimAnalysis(number) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            // dispatch(AppAction.appLoading(true));
            NewdanhmucphieuxuatService.getSimAnalysis(number).then((response) => {
                dispatch(success(response.data));
                resolve(response);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                // dispatch(AppAction.appLoading(false));
            })
        })
    };
    function success(data) { return { type: NEWDANHMUCPHIEUXUAT_GET_SIM_ANALYSIS_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUXUAT_GET_SIM_ANALYSIS_FAILD, error } }
}

function updateHomepageFilter(payload) {
    return { type: NEWDANHMUCPHIEUXUAT_UPDATE_HOMEPAGE_FILTER, data: payload }
}

function homepageList() {
    return (dispatch, getState) => {
        const { newdanhmucphieuxuat } = getState();
        dispatch(AppAction.appLoading(true));

        const { homepageNewdanhmucphieuxuatFilter } = newdanhmucphieuxuat;
        const homepageNewdanhmucphieuxuatPage = homepageNewdanhmucphieuxuatFilter.homepageNewdanhmucphieuxuatPage;
        const homepageNewdanhmucphieuxuatLimit = homepageNewdanhmucphieuxuatFilter.homepageNewdanhmucphieuxuatLimit;

        return new Promise((resolve, reject) => {
            NewdanhmucphieuxuatService.homepageList(homepageNewdanhmucphieuxuatFilter).then((rs) => {
                if (!!homepageNewdanhmucphieuxuatFilter && homepageNewdanhmucphieuxuatFilter.homepageNewdanhmucphieuxuatPage === 0) {
                    dispatch(success({
                        homepageNewdanhmucphieuxuatItems: rs.data.values,
                        homepageNewdanhmucphieuxuatTotal: rs.data.count,
                    }));
                } else {
                    const oldItems = newdanhmucphieuxuat.homepageNewdanhmucphieuxuatItems;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = homepageNewdanhmucphieuxuatLimit * homepageNewdanhmucphieuxuatPage; i < homepageNewdanhmucphieuxuatLimit * homepageNewdanhmucphieuxuatPage + homepageNewdanhmucphieuxuatLimit; i++) {
                        if (typeof rsDataValues[i - homepageNewdanhmucphieuxuatLimit * homepageNewdanhmucphieuxuatPage] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - homepageNewdanhmucphieuxuatLimit * homepageNewdanhmucphieuxuatPage];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        homepageNewdanhmucphieuxuatItems: uniqueItems,
                        homepageNewdanhmucphieuxuatTotal: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: NEWDANHMUCPHIEUXUAT_HOMEPAGE_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUXUAT_HOMEPAGE_LIST_FAILD, error } }
}

function homepageFindOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucphieuxuatService.homepageFindOne(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCPHIEUXUAT_HOMEPAGE_ONE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUXUAT_HOMEPAGE_ONE_FAILD, error } }
}

function updateFilter(payload) {
    return { type: NEWDANHMUCPHIEUXUAT_UPDATE_FILTER, data: payload }
}

function listNoLimit() {
    return (dispatch, getState) => {
      const { account } = getState()
      dispatch(AppAction.appLoading(true));
      NewdanhmucphieuxuatService.listNoLimit().then((rs) => {
        dispatch(success({
            items: rs.data.values,
            total: rs.data.count
        }));
      }).catch((error) => {
        dispatch(failure(error));
      }).finally(() => {
        dispatch(AppAction.appLoading(false));
      })
    };
    function success(data) { return { type: NEWDANHMUCPHIEUXUAT_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUXUAT_LIST_FAILD, error } }
  }

function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucphieuxuatService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCPHIEUXUAT_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUXUAT_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { newdanhmucphieuxuat } = getState()
        dispatch(AppAction.appLoading(true));
        NewdanhmucphieuxuatService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...newdanhmucphieuxuat.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCPHIEUXUAT_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUXUAT_LIST_FAILD, error } }
}

function saveDataUpload(payload) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        let count = 0;
        let errorRows = {};
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            NewdanhmucphieuxuatService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                // if (count === payload.length) {
                //     dispatch(success(rs));
                //     dispatch(AppAction.appLoading(false));
                // }

                if (rs.data.errorRows) {
                    Object.entries(rs.data.errorRows).forEach(([key, value]) => {
                        errorRows[i * 200 + Number(key)] = value;
                    });
                }

                if (i + 200 >= payload.length) {
                    dispatch(handleErrors(errorRows));
                    dispatch(success(rs));
                    dispatch(NewdanhmucphieuxuatAction.list());
                    alert("Tải file thành công: \"" + payload[0].ten_file_upload + "\" (" + count + " bản ghi)");
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function handleErrors(data) { return { type: NEWDANHMUCPHIEUXUAT_HANDLE_IMPORT_ERRORS, data } }
    function success(data) { return { type: NEWDANHMUCPHIEUXUAT_SAVE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUXUAT_SAVE_FAILD, error } }
}

function findPackage(ten_goi_cuoc) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            NewdanhmucphieuxuatService.findPackage(ten_goi_cuoc)
            .then(response => {
                // Handle the successful response
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                reject(error); // Reject the promise with the error
            });
        });
    };
}

function listExport() {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            const { newdanhmucphieuxuat } = getState();

            const { filter } = newdanhmucphieuxuat;

            // Perform your asynchronous operation (e.g., API call)
            NewdanhmucphieuxuatService.listExport(filter)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    }
    function success(data) { return { type: NEWDANHMUCPHIEUXUAT_LIST_EXPORT_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUXUAT_LIST_EXPORT_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        const { newdanhmucphieuxuat } = getState();
        dispatch(AppAction.appLoading(true));

        const { filter } = newdanhmucphieuxuat;
        const page = filter.page;
        const limit = filter.limit;

        return new Promise((resolve, reject) => {
            NewdanhmucphieuxuatService.findAll(filter.page, filter.limit, filter).then((rs) => {
                if (!!filter && filter.page === 0) {
                    dispatch(success({
                        items: rs.data.values,
                        total: rs.data.count,
                    }));
                } else {
                    const oldItems = newdanhmucphieuxuat.items;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = limit * page; i < limit * page + limit; i++) {
                        if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - limit * page];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        items: uniqueItems,
                        total: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: NEWDANHMUCPHIEUXUAT_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUXUAT_LIST_FAILD, error } }
}

function importData(payload) {
    return { type: NEWDANHMUCPHIEUXUAT_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            NewdanhmucphieuxuatService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(NewdanhmucphieuxuatAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: NEWDANHMUCPHIEUXUAT_SAVE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUXUAT_SAVE_FAILD, error } }
}

function create(payload, creatingFromAway = false) {
    return dispatch => {
        if (!creatingFromAway) dispatch(AppAction.appLoading(true));
        NewdanhmucphieuxuatService.create(payload).then((rs) => {
            dispatch(success(rs));
            if (!creatingFromAway) dispatch(NewdanhmucphieuxuatAction.list())
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể tạo, có thể do trùng số phiếu!");
        }).finally(() => {
            if (!creatingFromAway) dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCPHIEUXUAT_CREATE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUXUAT_CREATE_FAILD, error } }
}

function update(id, payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucphieuxuatService.update(id, payload).then((rs) => {
            dispatch(success(rs));
            dispatch(NewdanhmucphieuxuatAction.list())
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể cập nhật, có thể do trùng số phiếu!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCPHIEUXUAT_CREATE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUXUAT_CREATE_FAILD, error } }
}

function del(id) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucphieuxuatService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(NewdanhmucphieuxuatAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCPHIEUXUAT_DEL_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUXUAT_DEL_FAILD, error } }
}

function findOne(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        return new Promise((resolve, reject) => {
            NewdanhmucphieuxuatService.find(id).then((rs) => {
                dispatch(success(rs.data));
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: NEWDANHMUCPHIEUXUAT_ONE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUXUAT_ONE_FAILD, error } }
}

function assign(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucphieuxuatService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(NewdanhmucphieuxuatAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}

function history(payload) {
    return (dispatch, getState) => {
        const { newdanhmucphieuxuat } = getState()
        dispatch(AppAction.appLoading(true));
        NewdanhmucphieuxuatService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...newdanhmucphieuxuat.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCPHIEUXUAT_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUXUAT_HISTORY_LIST_FAILD, error } }
}

function sendOrder(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucphieuxuatService.sendOrder(payload).then((rs) => {
            dispatch(success(rs));
            alert("Đặt hàng thành công!");
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể đặt sim này, có thể do hiện tại sim này đã bán. Bạn vui lòng chọn sim khác. Xin cảm ơn!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCPHIEUXUAT_ORDER_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUXUAT_ORDER_FAILD, error } }
}